import { get, post, put, remove } from "./http.service";

const MediaAssetService = {
  getAll: () => get("mediaAsset"),
  create: body => post("mediaAsset", body),
  update: (id, body) => put(`mediaAsset/${id}`, body),
  remove: id => remove(`mediaAsset/${id}`),
};

export default MediaAssetService;
